"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_i18next_1 = require("react-i18next");
const zod_1 = require("zod");
const react_hook_form_1 = require("react-hook-form");
const zod_2 = require("@hookform/resolvers/zod");
const react_bootstrap_1 = require("react-bootstrap");
const axios_1 = __importDefault(require("axios"));
const components_1 = require("../../../../shared/components");
const LoanRequestDeliveryService_1 = require("../../../../shared/services/LoanRequestDeliveryService");
const helpers_1 = require("../../../../shared/helpers");
const Login_1 = __importDefault(require("../../pages/auth/Login"));
const http_requests_1 = require("../../../../shared/http-requests");
const hooks_1 = require("../../../../shared/hooks");
const const_1 = require("../../../../shared/const");
const query_string_1 = __importDefault(require("query-string"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const schema = zod_1.z.object({
    codLibrary: zod_1.z.number({ required_error: 'LoanRequest.origemObrigatorio' }),
    local: zod_1.z
        .string({ required_error: 'LoanRequest.localObrigatorio' })
        .min(1, 'LoanRequest.localObrigatorio'),
    volume: zod_1.z
        .string({ required_error: 'LoanRequest.volumeObrigatorio' })
        .min(1, 'LoanRequest.volumeObrigatorio'),
    tomo: zod_1.z
        .string({ required_error: 'LoanRequest.tomoObrigatorio' })
        .min(1, 'LoanRequest.tomoObrigatorio'),
    parte: zod_1.z
        .string({ required_error: 'LoanRequest.parteObrigatoria' })
        .min(1, 'LoanRequest.parteObrigatoria'),
    material: zod_1.z
        .string({ required_error: 'LoanRequest.tipoMaterialObrigatorio' })
        .min(1, 'LoanRequest.tipoMaterialObrigatorio'),
    selected_time: zod_1.z
        .object({
        hour_start: zod_1.z
            .string()
            .min(1, 'LoanRequest.horarioDeRetiradaInicialObrigatorio'),
        hour_end: zod_1.z
            .string()
            .min(1, 'LoanRequest.horarioDeRetiradaFinalObrigatorio'),
        range: zod_1.z.number(),
    }, { invalid_type_error: 'LoanRequest.horarioDeRetiradaObrigatorio' })
        .optional(),
    phone: zod_1.z.string().nullable(),
    email: zod_1.z
        .string()
        .email('LoanRequest.emailInvalido')
        .or(zod_1.z.literal(''))
        .nullable(),
});
const LoanRequestDelivery = ({ codAcervo, referencia, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, getValues, } = (0, react_hook_form_1.useForm)({
        resolver: (0, zod_2.zodResolver)(schema),
        defaultValues: {},
    });
    const changedcodLibraryState = watch('codLibrary');
    const changedLocalFormState = watch('local');
    const changedVolume = watch('volume');
    const changedTome = watch('tomo');
    const { getAll } = (0, hooks_1.usePrefiterParams)();
    const [solicitacaoEmprestimoLabels, setSolicitacaoEmprestimoLabels] = (0, react_1.useState)(null);
    const [loadingSolicitacaoEmprestimoLabels, setLoadingSolicitacaoEmprestimoLabels,] = (0, react_1.useState)(false);
    const [loanRequestInitialData, setLoanRequestInitialData] = (0, react_1.useState)(null);
    const [loanRequestLocalData, setLoanRequestLocalData] = (0, react_1.useState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [deliveryData, setDeliveryData] = (0, react_1.useState)(null);
    const [selectedOriginLibrary, setSelectedOriginLibrary] = (0, react_1.useState)();
    const [selectedPickupLocationLibrary, setSelectedPickupLocationLibrary] = (0, react_1.useState)();
    const [loadingSend, setLoadingSend] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setSelectedOriginLibrary(changedcodLibraryState);
    }, [changedcodLibraryState]);
    (0, react_1.useEffect)(() => {
        setSelectedPickupLocationLibrary(changedLocalFormState);
    }, [changedLocalFormState]);
    const history = (0, react_router_dom_1.useHistory)();
    const { consulta, opcoesResultado, filtros } = (0, react_redux_1.useSelector)((state) => state.pesquisa);
    const ultimoLogRx = (0, react_redux_1.useSelector)((state) => state.pesquisa.log[state.pesquisa.log.length - 1]);
    const location = (0, react_router_dom_1.useLocation)();
    const urlBackBiblioteca = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        try {
            if (consulta && consulta.searchVersion === const_1.VERSAO_PESQUISA_COMPLETA) {
                return {
                    pathname: (_a = ultimoLogRx === null || ultimoLogRx === void 0 ? void 0 : ultimoLogRx.url) === null || _a === void 0 ? void 0 : _a.pathname,
                    search: `?${(_b = ultimoLogRx === null || ultimoLogRx === void 0 ? void 0 : ultimoLogRx.url) === null || _b === void 0 ? void 0 : _b.search}`,
                    state: {
                        origin: location && location.pathname,
                    },
                };
            }
            const parsedSearch = query_string_1.default.parse((_c = ultimoLogRx === null || ultimoLogRx === void 0 ? void 0 : ultimoLogRx.url) === null || _c === void 0 ? void 0 : _c.search);
            parsedSearch.page = opcoesResultado.paginaAtiva;
            parsedSearch.per_page = opcoesResultado.quantPag;
            parsedSearch.order_by = opcoesResultado.ordenacaoCombo;
            parsedSearch.direction = opcoesResultado.ordenacao;
            if (filtros && filtros.length > 0) {
                filtros.forEach((filtro) => {
                    if (parsedSearch[`f${filtro.tipo}`]) {
                        parsedSearch[`f${filtro.tipo}`] += `,${filtro.codigo}`;
                    }
                    else {
                        parsedSearch[`f${filtro.tipo}`] = filtro.codigo;
                    }
                });
            }
            const searchQuery = query_string_1.default.stringify(parsedSearch);
            return {
                pathname: (_d = ultimoLogRx === null || ultimoLogRx === void 0 ? void 0 : ultimoLogRx.url) === null || _d === void 0 ? void 0 : _d.pathname,
                search: `?${searchQuery}`,
                state: {
                    origin: location && location.pathname,
                },
            };
        }
        catch (e) {
            return null;
        }
    }, [consulta, ultimoLogRx, filtros, location, opcoesResultado]);
    const goToListing = () => {
        if (urlBackBiblioteca && (urlBackBiblioteca === null || urlBackBiblioteca === void 0 ? void 0 : urlBackBiblioteca.pathname)) {
            history.push({
                pathname: urlBackBiblioteca.pathname,
                search: urlBackBiblioteca === null || urlBackBiblioteca === void 0 ? void 0 : urlBackBiblioteca.search,
                state: urlBackBiblioteca === null || urlBackBiblioteca === void 0 ? void 0 : urlBackBiblioteca.state
            });
        }
        else {
            window.location.replace(`/acervo/${codAcervo}`);
        }
    };
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        const { token } = cancelTokenSrc;
        setLoadingSolicitacaoEmprestimoLabels(true);
        // @ts-ignore
        http_requests_1.SolicitacaoEmprestimoAPI.getSolicitacaoEmprestimoLabels(token)
            .then(response => {
            const { data } = response;
            if (data) {
                setSolicitacaoEmprestimoLabels(data);
            }
            setLoadingSolicitacaoEmprestimoLabels(false);
        })
            .catch(error => {
            console.error('Erro ao obter labels da solitiação de emprestimo', error);
            setLoadingSolicitacaoEmprestimoLabels(false);
        });
        return () => cancelTokenSrc.cancel();
    }, []);
    const fetchRequestLoanInitialData = (cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
        const { id: campus, id_biblioteca: bibliotecas } = getAll();
        const response = yield (0, LoanRequestDeliveryService_1.getLoanRequestInitialData)(codAcervo, campus, bibliotecas, cancelToken);
        const { data } = response;
        if (data) {
            try {
                return data;
            }
            catch (ex) {
                if (!axios_1.default.isCancel(ex))
                    console.log('Error on request data:  ', ex);
            }
        }
        return null;
    });
    const fetchDeliveryData = (codBiblioteca) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, LoanRequestDeliveryService_1.getDeliveryData)(codBiblioteca);
        const { data } = response;
        if (data) {
            try {
                return data;
            }
            catch (ex) {
                console.log('Error on request data:  ', ex);
            }
        }
        return null;
    });
    const fetchDeliveryLocalData = (local) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOriginLibrary)
            return null;
        try {
            const response = yield (0, LoanRequestDeliveryService_1.getDeliveryLocalData)(selectedOriginLibrary, local);
            const { data } = response;
            if (data)
                return data;
        }
        catch (error) {
            if (!axios_1.default.isCancel(error)) {
                helpers_1.APIHelper.tratarErro(error);
                console.log('Error on request data:  ', error);
                setValue('local', '');
            }
        }
        return null;
    });
    const handleChangeOriginLibrary = (0, react_1.useCallback)((codBiblioteca) => __awaiter(void 0, void 0, void 0, function* () {
        setValue('codLibrary', parseInt(codBiblioteca, 10));
        setSelectedOriginLibrary(codBiblioteca);
        setValue('local', '-1');
        const data = yield fetchDeliveryData(codBiblioteca);
        if (data) {
            setDeliveryData(data);
        }
    }), [setValue, setDeliveryData, setSelectedOriginLibrary]);
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        const { token } = cancelTokenSrc;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const loanRequestInitialData = yield fetchRequestLoanInitialData(token);
            if (loanRequestInitialData) {
                setLoanRequestInitialData(loanRequestInitialData);
                const { originLibraries } = loanRequestInitialData;
                if (originLibraries && originLibraries.length === 1) {
                    handleChangeOriginLibrary(parseInt(`${originLibraries[0].cod_biblioteca}`, 10));
                }
            }
        }))();
        return () => {
            cancelTokenSrc.cancel();
        };
    }, [setLoanRequestInitialData]);
    const handleChangeLocal = (0, react_1.useCallback)((local) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOriginLibrary)
            return;
        setValue('local', local);
        setSelectedPickupLocationLibrary(local);
        const data = yield fetchDeliveryLocalData(local);
        if (data) {
            setLoanRequestLocalData(data);
        }
    }), [setValue, setLoanRequestLocalData, selectedOriginLibrary]);
    const handleSubmitForm = (0, react_1.useCallback)((data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoadingSend(true);
            const response = yield (0, LoanRequestDeliveryService_1.store)(codAcervo, data);
            const { data: responseData } = response;
            if (responseData === null || responseData === void 0 ? void 0 : responseData.success) {
                helpers_1.ToastifyHelper.success(t('SolicitacaoEfetuadaSucesso'));
                helpers_1.ToastifyHelper.info(t('LoanRequest.MsgSucesso'));
                setLoanRequestLocalData(undefined);
                setDeliveryData(null);
                reset({
                    volume: '99999',
                    tomo: '99999',
                    parte: '99999',
                    material: '0',
                    phone: '',
                    email: '',
                });
            }
            setLoadingSend(false);
            goToListing();
        }
        catch (error) {
            if (!axios_1.default.isCancel(error)) {
                setLoadingSend(false);
                helpers_1.APIHelper.tratarErro(error);
            }
        }
    }), [codAcervo, reset]);
    const originLibraryLabel = (0, react_1.useMemo)(() => {
        if (loadingSolicitacaoEmprestimoLabels) {
            return t('Carregando');
        }
        if (solicitacaoEmprestimoLabels != null &&
            (solicitacaoEmprestimoLabels === null || solicitacaoEmprestimoLabels === void 0 ? void 0 : solicitacaoEmprestimoLabels.originLibraryLabel)) {
            return solicitacaoEmprestimoLabels.originLibraryLabel;
        }
        return t('UnidadeInformacaoOrigem');
    }, [solicitacaoEmprestimoLabels, loadingSolicitacaoEmprestimoLabels]);
    const filteredVolumes = (0, react_1.useMemo)(() => {
        if (!loanRequestInitialData || !selectedOriginLibrary)
            return [];
        const { volumes, copiesAvailable } = loanRequestInitialData;
        return volumes.filter(v => {
            return copiesAvailable
                .filter(copy => parseInt(copy.cod_biblioteca, 10) ===
                parseInt(selectedOriginLibrary, 10))
                .some(copy => copy.volume === v.code);
        });
    }, [selectedOriginLibrary, loanRequestInitialData]);
    (0, react_1.useEffect)(() => {
        if (filteredVolumes.length === 1)
            setValue('volume', filteredVolumes[0].code);
    }, [filteredVolumes]);
    const filteredTomes = (0, react_1.useMemo)(() => {
        if (!loanRequestInitialData || !selectedOriginLibrary)
            return [];
        const { tomes, copiesAvailable } = loanRequestInitialData;
        const { volume } = getValues();
        return tomes.filter(t => {
            return copiesAvailable
                .filter(copy => parseInt(copy.cod_biblioteca, 10) ===
                parseInt(selectedOriginLibrary, 10))
                .some(copy => copy.tomo_exemplar === t.code &&
                (!volume || copy.volume === volume));
        });
    }, [selectedOriginLibrary, loanRequestInitialData, changedVolume]);
    (0, react_1.useEffect)(() => {
        if (filteredTomes.length === 1)
            setValue('tomo', filteredTomes[0].code);
    }, [filteredTomes]);
    const filteredParts = (0, react_1.useMemo)(() => {
        if (!loanRequestInitialData || !selectedOriginLibrary)
            return [];
        const { parts, copiesAvailable } = loanRequestInitialData;
        const { volume, tomo } = getValues();
        return parts.filter(pt => {
            return copiesAvailable
                .filter(copy => parseInt(copy.cod_biblioteca, 10) ===
                parseInt(selectedOriginLibrary, 10))
                .some(copy => copy.parte === pt.code &&
                (!volume || copy.volume === volume) &&
                (!tomo || copy.tomo_exemplar === tomo));
        });
    }, [
        selectedOriginLibrary,
        loanRequestInitialData,
        changedVolume,
        changedTome,
    ]);
    (0, react_1.useEffect)(() => {
        if (filteredParts.length === 1)
            setValue('parte', filteredParts[0].code);
    }, [filteredParts]);
    const renderReference = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Row, { className: "pad5" },
                react_1.default.createElement(reactstrap_1.Col, { xs: "12", className: "preto80 f500 s14" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "angle-right", className: "r10" }),
                    react_1.default.createElement("span", { className: "s15" },
                        referencia && (referencia === null || referencia === void 0 ? void 0 : referencia.desc_titulo),
                        ' '))),
            react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-solid-top b-cinza2 pad5" },
                react_1.default.createElement(reactstrap_1.Col, { xs: "12", className: "preto60 f400 s12" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "angle-right", className: "r10" }),
                    react_1.default.createElement("span", { className: "s13 ", dangerouslySetInnerHTML: {
                            __html: referencia && (referencia === null || referencia === void 0 ? void 0 : referencia.referencia),
                        } })))));
    };
    return (react_1.default.createElement(reactstrap_1.Row, { className: "pad5 animated fadeIn" },
        react_1.default.createElement(reactstrap_1.Col, { xs: "12", className: "d-md-none d-xs-block pt-3 pl-0 b-w1 b-solid-bottom b-cinza2" },
            (loanRequestInitialData === null || loanRequestInitialData === void 0 ? void 0 : loanRequestInitialData.infoText) ? (react_1.default.createElement("div", { className: "pad10 rad5 bkazul branco b10 animated fadeIn s14 sombraPadrao" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "info-circle", className: "r5" }),
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: loanRequestInitialData.infoText,
                    } }))) : '',
            renderReference()),
        loanRequestInitialData !== null ? ((loanRequestInitialData === null || loanRequestInitialData === void 0 ? void 0 : loanRequestInitialData.error) ? (react_1.default.createElement(reactstrap_1.Col, { xs: "12", md: "7", className: "b-solid-right b-w1 b-tema40 text-center" },
            react_1.default.createElement("div", { className: "p-5 animated fadeIn" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "exclamation-triangle", className: "laranja s20 r10" }),
                react_1.default.createElement("span", { className: "laranja s17" }, t(loanRequestInitialData.error))))) : (react_1.default.createElement(reactstrap_1.Col, { xs: "12", md: "7", className: "b-solid-right b-w1 b-tema40" },
            react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom pad10" },
                react_1.default.createElement(reactstrap_1.Col, { md: "12" },
                    react_1.default.createElement("span", { className: "f500 cortxt s13" },
                        t('ParaSolicitarEmprestimoPreencha'),
                        ":"))),
            loanRequestInitialData.originLibraries && (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13", htmlFor: "bib_origem" },
                        originLibraryLabel,
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { as: "select", name: "bib_origem", className: "b-tema20 rad10 s14 cortxt", disabled: loanRequestInitialData
                            .originLibraries.length === 1, value: selectedOriginLibrary || '-1', onChange: e => handleChangeOriginLibrary(e.target.value), isInvalid: errors.codLibrary !== undefined },
                        react_1.default.createElement("option", { disabled: true, value: "-1" },
                            t('SelecioneOpcao'),
                            "..."),
                        loanRequestInitialData.originLibraries.map(ol => (react_1.default.createElement("option", { key: `bib-orig-${ol.cod_biblioteca}`, className: "preto70", value: ol.cod_biblioteca }, ol.desc_biblioteca)))),
                    errors.codLibrary ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_a = errors.codLibrary) === null || _a === void 0 ? void 0 : _a.message))) : ('')))),
            react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13", htmlFor: "local-retirada" },
                        t('LocalDeRetirada'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: deliveryData === null, as: "select", name: "local-retirada", className: "b-tema20 rad10 s14 cortxt", value: selectedPickupLocationLibrary || '-1', onChange: e => {
                            handleChangeLocal(e.target.value);
                        }, isInvalid: errors.local !== undefined },
                        react_1.default.createElement("option", { disabled: true, value: "-1" },
                            t('SelecioneOpcao'),
                            "..."),
                        deliveryData && (deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.length) > 0
                            ? deliveryData.map(dd => (react_1.default.createElement("option", { key: `bib-dest-${dd.local}`, className: "preto70", value: dd.local }, dd.local)))
                            : ''),
                    errors.local ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_b = errors.local) === null || _b === void 0 ? void 0 : _b.message))) : (''))),
            // eslint-disable-next-line no-nested-ternary
            loanRequestLocalData ? ((loanRequestLocalData === null || loanRequestLocalData === void 0 ? void 0 : loanRequestLocalData.select_times) ? (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('LoanRequest.HorarioDeRetirada'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ disabled: deliveryData === null, as: "select", className: "b-tema20 rad10 s14 cortxt" }, register('selected_time', {
                        setValueAs: val => val
                            ? JSON.parse(val)
                            : null,
                    }), { isInvalid: errors.selected_time !==
                            undefined }),
                        react_1.default.createElement("option", { selected: true, value: "" },
                            t('SelecioneOpcao'),
                            "..."),
                        (loanRequestLocalData === null || loanRequestLocalData === void 0 ? void 0 : loanRequestLocalData.times) &&
                            ((_c = loanRequestLocalData === null || loanRequestLocalData === void 0 ? void 0 : loanRequestLocalData.times) === null || _c === void 0 ? void 0 : _c.length) > 0
                            ? loanRequestLocalData.times.map(item => (react_1.default.createElement("option", { key: `bib-dest-${item.hour_start}_${item.hour_end}`, className: "preto70", value: JSON.stringify({
                                    hour_start: item.hour_start,
                                    hour_end: item.hour_end,
                                    range: item.range,
                                }) },
                                item.hour_start,
                                ' ',
                                "a ",
                                item.hour_end)))
                            : ''),
                    errors.selected_time ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_d = errors.selected_time) === null || _d === void 0 ? void 0 : _d.message))) : ('')))) : (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2 text-center" },
                react_1.default.createElement(reactstrap_1.Col, { md: "12" },
                    react_1.default.createElement("label", null, t('LoanRequest.materialDisponivelAPartir', {
                        day: (loanRequestLocalData === null || loanRequestLocalData === void 0 ? void 0 : loanRequestLocalData.next_day)
                            ? t('LoanRequest.amanha')
                            : t('LoanRequest.hoje'),
                        start_time: loanRequestLocalData.hour_start,
                        end_time: loanRequestLocalData.hour_end,
                    })))))) : (''),
            filteredVolumes.length === 1 && ((_e = filteredVolumes[0].code) === null || _e === void 0 ? void 0 : _e.toString()) === '99999' ? (react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ type: "hidden", value: filteredVolumes[0].code }, register('volume')))) : (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('Volume'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", disabled: filteredVolumes.length === 0, className: "b-tema20 rad10 s14 cortxt" }, register('volume'), { isInvalid: errors.volume !== undefined }), filteredVolumes.map(({ code, label }) => (react_1.default.createElement("option", { key: code, value: code }, t(label))))),
                    errors.volume ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_f = errors.volume) === null || _f === void 0 ? void 0 : _f.message))) : ('')))),
            filteredTomes.length === 1 && ((_g = filteredTomes[0].code) === null || _g === void 0 ? void 0 : _g.toString()) === '99999' ? (react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ type: "hidden", value: filteredTomes[0].code }, register('tomo')))) : (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('Tomo'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ disabled: filteredTomes.length === 0, as: "select", className: "b-tema20 rad10 s14 cortxt" }, register('tomo'), { isInvalid: errors.tomo !== undefined }), filteredTomes.map(({ code, label }) => (react_1.default.createElement("option", { key: code, value: code }, t(label))))),
                    errors.tomo ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_h = errors.tomo) === null || _h === void 0 ? void 0 : _h.message))) : ('')))),
            filteredParts.length === 1 && ((_j = filteredParts[0].code) === null || _j === void 0 ? void 0 : _j.toString()) === '99999' ? (react_1.default.createElement("input", Object.assign({ type: "hidden", value: filteredParts[0].code }, register('parte')))) : (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('Parte'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", className: "b-tema20 rad10 s14 cortxt" }, register('parte'), { isInvalid: errors.parte !== undefined }), filteredParts.map(({ code, label }) => (react_1.default.createElement("option", { key: code, value: code }, t(label))))),
                    errors.parte ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_k = errors.parte) === null || _k === void 0 ? void 0 : _k.message))) : ('')))),
            loanRequestInitialData.additionalMaterials
                .length === 1 && ((_l = loanRequestInitialData.additionalMaterials[0].code) === null || _l === void 0 ? void 0 : _l.toString()) === '0' ? (react_1.default.createElement("input", Object.assign({ type: "hidden", value: loanRequestInitialData
                    .additionalMaterials[0].code }, register('material')))) : (react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('MaterialAdicional'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", className: "b-tema20 rad10 s14 cortxt" }, register('material'), { isInvalid: errors.material !== undefined }), loanRequestInitialData.additionalMaterials.map(({ code, label }) => (react_1.default.createElement("option", { key: code, value: code }, t(label))))),
                    errors.material ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_m = errors.material) === null || _m === void 0 ? void 0 : _m.message))) : ('')))),
            react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('Telefone'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ type: "text", placeholder: "(DDD) 00000-0000", className: "b-tema20 rad10 s14 preto70" }, register('phone'))))),
            react_1.default.createElement(reactstrap_1.Row, { className: "b-w1 b-cinza2 b-solid-bottom p-2" },
                react_1.default.createElement(reactstrap_1.Col, { md: "3", xs: "12", className: "pb-md-0 pb-2" },
                    react_1.default.createElement("label", { className: "f500 preto70 s13" },
                        t('Email'),
                        ":")),
                react_1.default.createElement(reactstrap_1.Col, { md: "9", xs: "12" },
                    react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ type: "email", placeholder: t('PlaceholderEmail'), className: "b-tema20 rad10 s14 preto70" }, register('email'), { isInvalid: errors.email !== undefined })),
                    errors.email ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_o = errors.email) === null || _o === void 0 ? void 0 : _o.message))) : (''))),
            react_1.default.createElement(Login_1.default
            // @ts-ignore
            , { 
                // @ts-ignore
                embedded: true, labelAcessarAlternativo: t('EnviarSolicitacao'), loginCallback: (user) => {
                    handleSubmit(handleSubmitForm)();
                }, altRender: 
                // eslint-disable-next-line react/no-unstable-nested-components
                (auth) => auth ? (react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center py-2" }, loadingSend ? (react_1.default.createElement("div", { className: "p-5 mt-3" },
                    react_1.default.createElement(components_1.SpinnerConstructor, { visible: true, height: 70, width: 70, className: "cortxt70 s20" }))) : (react_1.default.createElement(reactstrap_1.Button, { className: "btn-generic--primeiro ml-0", onClick: () => handleSubmit(handleSubmitForm)() },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "check", className: "r10" }),
                    t('EnviarSolicitacao'))))) : (react_1.default.createElement("div", { className: "pad10" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "exclamation-circle", className: "laranja s14 r10" }),
                    react_1.default.createElement("span", { className: "preto90 s14" }, t('NecessarioFazerLoginSolicitacao')))) })))) : (react_1.default.createElement(reactstrap_1.Col, { xs: "12", md: "7", className: "b-solid-right b-w1 b-tema40 text-center" },
            react_1.default.createElement("div", { className: "p-5 mt-3" },
                react_1.default.createElement(components_1.SpinnerConstructor, { visible: true, height: 70, width: 70, className: "cortxt70 s20" })))),
        react_1.default.createElement(reactstrap_1.Col, { md: "5", className: "d-md-block d-none pt-3" },
            (loanRequestInitialData === null || loanRequestInitialData === void 0 ? void 0 : loanRequestInitialData.infoText) ? (react_1.default.createElement("div", { className: "pad10 rad5 bkazul branco b10 animated fadeIn s14 sombraPadrao" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "info-circle", className: "r5" }),
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: loanRequestInitialData.infoText,
                    } }))) : '',
            renderReference())));
};
exports.default = LoanRequestDelivery;
